// @flow
import type { Action } from '../actions/types';
import { SUBMIT_RATING, TOGGLE_RATING_DLG, SET_RATING_PARAMS } from '../actions/types';

export type RatingState = {|
	fetched: boolean,
	ratingQuestions: null | {},
	submittedRating: boolean,
	error: typeof Error | null,
	ratingDlgState: boolean,
	type: string,
	pod: string,
|};

const initialState: RatingState = {
	fetched: false,
	ratingQuestions: null,
	submittedRating: false,
	error: null,
	ratingDlgState: false,
	type: '',
	pod: '',
};

export const ratingReducer = (state: RatingState = initialState, action: Action) => {
	const { type, payload = {} } = action;
	switch (type) {
		case SUBMIT_RATING:
			return {
				...state,
				submittedRating: false,
			};

		case TOGGLE_RATING_DLG:
			return {
				...state,
				ratingDlgState: payload,
			};

		case SET_RATING_PARAMS:
			return {
				...state,
				type: payload.type,
				pod: payload.pod,
			};

		default:
			return state;
	}
};
